// Per-scope chart definitions for KjpChart.vue (INFS-1283), taken verbatim
// from each scope's own combo chart in the source workbook.
//
// Sibling to titles.js rather than folded into it: titles.js holds each
// scope's *table* heading, which is different text from its *chart* title
// (e.g. R01's table says "DATA SKOP KERJA R01 PAVEMENT", its chart says
// "PENGGUNAAN SYILING TAMPALAN PAVEMEN (R01)"). Kept as data, not a switch
// on `scope` inside the component, because the series composition is not
// uniform across scopes: R01 alone plots a bar for its monthly allocation,
// R02 and R06 plot no bars at all. That asymmetry is the workbook's own
// design (confirmed intent), not something to normalise away.
//
// `source` names a key on model.projections that supplies this series'
// values. `unmeasuredSource`, when present, names the sibling boolean array
// on model.projections marking which months must not be drawn as real data
// (see chartGeometry.js) — `monthlyAllocation` and `annualCeiling` have no
// such array because they derive from contract length, never from
// measurements, so they always plot in full.
//
// `axis` says which valAx (in the workbook's own terms) a series plots
// against. In `xl/charts/chart1.xml`, R01 puts its two bar series on a left
// valAx (max 85000) and its two line series on a right valAx (max 280000) —
// the annual ceiling line runs ten-to-twelve times higher than the monthly
// bar, so sharing one axis would squash the bars to a few pixels. R02's two
// series share a unit and R06's chart7.xml puts both lines on one axis, so
// neither sets `axis` — chartGeometry.js then falls every series back to the
// same 'left' group, i.e. today's single shared-axis behaviour. This is the
// one place that distinction is declared; chartGeometry.js reads it as data
// and never checks a scope name.
export const KJP_CHART_TITLES = {
  R01: 'PENGGUNAAN SYILING TAMPALAN PAVEMEN (R01)',
  R02: 'PENGGUNAAN SYILING ROAD SHOULDER (R02)',
  R06: 'PENGGUNAAN SYILING GARISAN JALAN (R06)',
}

export const KJP_CHART_SERIES = {
  R01: [
    { key: 'bars', label: 'Jumlah Tampalan (m²)', type: 'bar', axis: 'left',
      color: '#ED7D31', source: 'bars', unmeasuredSource: 'barsUnmeasured' },
    { key: 'monthlyAllocation', label: 'Peruntukan Siling Bulanan (m²)', type: 'bar', axis: 'left',
      color: '#4472C4', source: 'monthlyAllocation' },
    { key: 'annualCeiling', label: 'Unjuran Siling Tahunan (m²)', type: 'line', axis: 'right',
      color: '#FFC000', source: 'annualCeiling' },
    { key: 'cumulativeUsage', label: 'Unjuran Penggunaan Siling (m²)', type: 'line', axis: 'right',
      color: '#5B9BD5', source: 'cumulativeUsage', unmeasuredSource: 'cumulativeUsageUnmeasured' },
  ],
  R02: [
    { key: 'cumulativeUsage', label: 'Unjuran Penggunaan Syiling (km)', type: 'line',
      color: '#0070C0', source: 'cumulativeUsage', unmeasuredSource: 'cumulativeUsageUnmeasured' },
    { key: 'annualCeiling', label: 'Unjuran Syiling Tahunan (km)', type: 'line',
      color: '#FFC000', source: 'annualCeiling' },
  ],
  R06: [
    { key: 'annualCeiling', label: 'Unjuran Siling Tahunan (m²)', type: 'line',
      color: '#FFC000', source: 'annualCeiling' },
    { key: 'cumulativeUsage', label: 'Unjuran Penggunaan Siling (m²)', type: 'line',
      color: '#5B9BD5', source: 'cumulativeUsage', unmeasuredSource: 'cumulativeUsageUnmeasured' },
  ],
}
